import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { medicationsTypesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import Chip from '@material-ui/core/Chip'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = medicationType => {
    const { onClose, addMedicationType, editMedicationType, changeMessage } = this.props
    if (medicationType._id) {
      editMedicationType(medicationType).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addMedicationType(medicationType).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, medicationType) => {
    e.preventDefault()
    const { setMedicationTypeFormTouched } = this.props

    if (this.props.medicationTypeFormErrors.valid) {
      this.handleSave(medicationType)
    } else {
      setMedicationTypeFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      medicationType,
      handleChangeMedicationType,
      loadingMedicationType,
      medicationTypeFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('tiposmedicamentos', token)

    return (
      <div>
        <Dialog
          modalId={medicationType._id ? 'tipos-medicamentos-editar' : 'tipos-medicamentos-novo'}
          modalParams={{ registro: medicationType._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingMedicationType ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(medicationType._id ? 'tipos-medicamentos-editar' : 'tipos-medicamentos-novo') + '-title'}>
                {isReadOnly ? (
                  'Tipo de Medicamento'
                ) : (
                  <Fragment>
                    {medicationType._id
                      ? 'Editar tipo de medicamento'
                      : 'Cadastrar tipo de medicamento'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'medicationType-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, medicationType)
                  }}
                >
                  <FormControl
                    error={
                      !((medicationTypeFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Tipo de Medicamento</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeMedicationType({ ...medicationType, nome: e.target.value })
                      }}
                      value={medicationType.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((medicationTypeFormErrors.fields || {})['nome'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationTypeFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'medicationType-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    medicationType: state.medicationsTypes.medicationType,
    loadingMedicationType: state.medicationsTypes.loadingMedicationType,
    medicationTypeFormErrors: state.medicationsTypes.medicationTypeFormErrors,
    formTouched: state.medicationsTypes.medicationTypeFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsTypesActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsTypesActions.closeModal())
    },
    handleChangeMedicationType: medicationType => {
      dispatch(medicationsTypesActions.handleChangeMedicationType(medicationType))
    },
    addMedicationType: medicationType => {
      return dispatch(medicationsTypesActions.addMedicationType(medicationType))
    },
    editMedicationType: medicationType => {
      return dispatch(medicationsTypesActions.editMedicationType(medicationType))
    },
    setMedicationTypeFormTouched: medicationType => {
      dispatch(medicationsTypesActions.setMedicationTypeFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/MedicationsTypes/EditModal.js